import updateImportPlayers from "./importPlayers.ts";

export default updateImportPlayers;
